<template>
  <div class="vehicle-type-display" id="tabbedRowsAngleView" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="row title-row">
        <span class="text-center">Shop Our Vehicle Lineup</span>
    </div>
    <div class="row vehicle-row text-center">
        <div class="container">
            <ul class="nav nav-pills" role="tablist">
                <li role="cars-tab" :class="[(images.sedans.length > 0) ? 'active' : '']" v-if="images.sedans.length > 0">
                    <a href="#cars-tab" aria-controls="cars-tab" role="tab" data-toggle="pill">{{ brandName === "Hyundai" ? 'Sedans' : 'Cars' }}</a>
                </li>
                <li role="suvs-tab" :class="[(images.sedans.length === 0) ? 'active' : '']" v-if="images.suvs.length > 0">
                    <a href="#suvs-tab" aria-controls="suvs-tab" role="tab" data-toggle="pill">{{ brandName === "Ford" ? 'SUVs & Crossovers' : 'SUVs'}}</a>
                </li>
                <li role="trucks-tab" v-if="images.trucks.length > 0">
                    <a href="#trucks-tab" aria-controls="trucks-tab" role="tab" data-toggle="pill">{{ brandName === "Ford" ? 'Trucks & Vans' : 'Trucks'}}</a>
                </li>
                <li role="evs-tab" v-if="images.evs && images.evs.length > 0 && (brandName === 'Ford' || brandName === 'Hyundai')">
                    <a href="#evs-tab" aria-controls="evs-tab" role="tab" data-toggle="pill">{{ brandName === "Hyundai" ? 'Electrified' : 'EV & Hybrid' }}</a>
                </li>
            </ul>
        </div>
        <div class="col-xs-12 col-centered">
            <div class="tab-content">
                <div role="tabpanel" class="tab-pane fade in" :class="[(images.sedans.length > 0) ? 'active' : '']" id="cars-tab" v-if="images.sedans.length > 0">
                    <div class="carousel slide hidden-xs" id="theCarousel1" v-if="images.sedans.length >= 4">
                        <div class="carousel-inner">
                            <div class="item" :class="[index === 0 ? activeClass: '']" v-for="(sedan, index) in images.sedans" :key="sedan.index">
                                <div class="col-sm-3">
                                    <a href="#">
                                        <img class="vehicle-img img-responsive center-block" :alt="sedan.modelName" :src="sedan.angleView">
                                        <p><strong>{{sedan.modelName}}</strong></p>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <a class="left carousel-control" href="#theCarousel1" data-slide="prev"><i
                                class="glyphicon glyphicon-chevron-left"></i></a>
                        <a class="right carousel-control" href="#theCarousel1" data-slide="next"><i
                                class="glyphicon glyphicon-chevron-right"></i></a>
                    </div>
                    <div v-else class="desktop-row hidden-xs">
                        <div class="col-sm-3" v-for="sedan in images.sedans" :key="sedan.modelName">
                            <a href="#">
                                <img class="vehicle-img img-responsive center-block" :alt="sedan.modelName" :src="sedan.angleView">
                                <p><strong>{{sedan.modelName}}</strong></p>
                            </a>
                        </div>
                    </div>
                    <div class="mobile-row visible-xs">
                        <div class="col-xs-6" v-for="sedan in images.sedans" :key="sedan.modelName">
                            <a href="#">
                                <img class="vehicle-img img-responsive center-block" :alt="sedan.modelName" :src="sedan.angleView">
                                <p>{{sedan.modelName}}</p>
                            </a>
                        </div>
                    </div>
                </div>
                <div role="tabpanel" class="tab-pane fade" id="suvs-tab" :class="[(images.sedans.length === 0) ? 'active' : '']" v-if="images.suvs.length > 0">
                    <div class="carousel slide hidden-xs" id="theCarousel2" v-if="images.suvs.length >= 4">
                        <div class="carousel-inner">
                            <div class="item" :class="[index === 0 ? activeClass: '']" v-for="(suv, index) in images.suvs" :key="suv.index">
                                <div class="col-sm-3">
                                    <a href="#">
                                        <img class="vehicle-img img-responsive center-block"  :alt="suv.modelName" :src="suv.angleView">
                                        <p><strong>{{suv.modelName}}</strong></p>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <a class="left carousel-control" href="#theCarousel2" data-slide="prev">
                            <i class="glyphicon glyphicon-chevron-left"></i>
                        </a>
                        <a class="right carousel-control" href="#theCarousel2" data-slide="next">
                            <i class="glyphicon glyphicon-chevron-right"></i>
                        </a>
                    </div>
                    <div v-else class="desktop-row hidden-xs">
                        <div class="col-sm-3" v-for="suv in images.suvs" :key="suv.modelName">
                            <a href="#">
                                <img class="vehicle-img img-responsive center-block" :alt="suv.modelName" :src="suv.angleView">
                                <p><strong>{{suv.modelName}}</strong></p>
                            </a>
                        </div>
                    </div>
                    <div class="mobile-row visible-xs">
                        <div class="col-xs-6" v-for="suv in images.suvs" :key="suv.modelName">
                            <a href="#">
                                <img class="vehicle-img img-responsive center-block" :alt="suv.modelName" :src="suv.angleView">
                                <p>{{suv.modelName}}</p>
                            </a>
                        </div>
                    </div>
                </div>
                <div role="tabpanel" class="tab-pane fade" id="trucks-tab" :class="[(images.trucks.length === 0) ? 'active' : '']" v-if="images.trucks.length > 0">
                    <div class="carousel slide hidden-xs" id="theCarousel3" v-if="images.trucks.length >= 4">
                        <div class="carousel-inner">
                            <div class="item" :class="[index === 0 ? activeClass: '']" v-for="(truck, index) in images.trucks" :key="truck.index">
                                <div class="col-sm-3">
                                    <a href="#">
                                        <img class="vehicle-img img-responsive center-block"  :alt="truck.modelName" :src="truck.angleView">
                                        <p><strong>{{truck.modelName}}</strong></p>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <a class="left carousel-control" href="#theCarousel3" data-slide="prev">
                            <i class="glyphicon glyphicon-chevron-left"></i>
                        </a>
                        <a class="right carousel-control" href="#theCarousel3" data-slide="next">
                            <i class="glyphicon glyphicon-chevron-right"></i>
                        </a>
                    </div>
                    <div v-else class="desktop-row hidden-xs">
                        <div class="col-sm-3" v-for="truck in images.trucks" :key="truck.modelName">
                            <a href="#">
                                <img class="vehicle-img img-responsive center-block" :alt="truck.modelName" :src="truck.angleView">
                                <p><strong>{{truck.modelName}}</strong></p>
                            </a>
                        </div>
                    </div>
                    <div class="mobile-row visible-xs">
                        <div class="col-xs-6" v-for="truck in images.trucks" :key="truck.modelName">
                            <a href="#">
                                <img class="vehicle-img img-responsive center-block" :alt="truck.modelName" :src="truck.angleView">
                                <p>{{truck.modelName}}</p>
                            </a>
                        </div>
                    </div>
                </div>
                <div role="tabpanel" class="tab-pane fade" id="evs-tab" :class="[(images.evs.length === 0) ? 'active' : '']" v-if="images.evs && images.evs.length > 0 && (brandName === 'Ford' || brandName === 'Hyundai')">
                    <div class="carousel slide hidden-xs" id="theCarousel4" v-if="images.evs.length >= 4">
                        <div class="carousel-inner">
                            <div class="item" :class="[index === 0 ? activeClass: '']" v-for="(ev, index) in images.evs" :key="ev.index">
                                <div class="col-sm-3">
                                    <a href="#">
                                        <img class="vehicle-img img-responsive center-block"  :alt="ev.modelName" :src="ev.angleView">
                                        <p><strong>{{ev.modelName}}</strong></p>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <a class="left carousel-control" href="#theCarousel4" data-slide="prev">
                            <i class="glyphicon glyphicon-chevron-left"></i>
                        </a>
                        <a class="right carousel-control" href="#theCarousel4" data-slide="next">
                            <i class="glyphicon glyphicon-chevron-right"></i>
                        </a>
                    </div>
                    <div v-else class="desktop-row hidden-xs">
                        <div class="col-sm-3" v-for="ev in images.evs" :key="ev.modelName">
                            <a href="#">
                                <img class="vehicle-img img-responsive center-block" :alt="ev.modelName" :src="ev.angleView">
                                <p><strong>{{ev.modelName}}</strong></p>
                            </a>
                        </div>
                    </div>
                    <div class="mobile-row visible-xs">
                        <div class="col-xs-6" v-for="ev in images.evs" :key="ev.modelName">
                            <a href="#">
                                <img class="vehicle-img img-responsive center-block" :alt="ev.modelName" :src="ev.angleView">
                                <p>{{ev.modelName}}</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import "../../static/bootstrap-3.3.7-dist/js/bootstrap.min.js";

export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand,
      activeClass: 'active'
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    }
  },
  mounted() {
    (function () {
      var multiCarousel = {
          init: function () {

              $('#tabbedRowsAngleView .carousel .item').each(function () {
                  var next = $(this).next();
                  if (!next.length) {
                      next = $(this).siblings(':first');
                  }
                  next.children(':first-child').clone().appendTo($(this));

                  for (var i = 0; i < 2; i++) {
                      next = next.next();
                      if (!next.length) {
                          next = $(this).siblings(':first');
                      }

                      next.children(':first-child').clone().appendTo($(this));
                  }
              });
          }
      }
      $('#theCarousel1').carousel({
          interval: 5000
      })

      $('#theCarousel2').carousel({
          interval: 5000
      })

      $('#theCarousel3').carousel({
          interval: 5000
      })

      $('#theCarousel4').carousel({
          interval: 5000
      })

      $(document).ready(multiCarousel.init);
  })(jQuery);
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  .vehicle-type-display {
      font-size: 18px;
      background: #fff;
      text-align: center;
      margin: 15px;
      padding: 15px 0;
      color: #333;
      font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }
  .vehicle-type-display .title-row {
      font-size: 32px;
      text-align: center;
  }
  .vehicle-type-display ul li {
      display: inline-block;
      float: none;
  }
  .vehicle-type-display ul {
      margin-bottom: 20px;
  }
  .vehicle-type-display .item img,
  .vehicle-type-display .desktop-row img,
  .vehicle-type-display .mobile-row img {
      transform: perspective(1px) translateZ(0);
      -webkit-transition-duration: 0.3s;
      transition-duration: 0.3s;
      -webkit-transition-property: transform;
      transition-property: transform;
      max-height: 155px;
  }
  .vehicle-type-display .item a, .vehicle-type-display .desktop-row a,
  .vehicle-type-display .mobile-row a {
      color: var(--primary-dark) !important;
      text-decoration: none;
  }
  .vehicle-type-display .item p,
  .vehicle-type-display strong {
      text-transform: uppercase;
  }
  .vehicle-type-display .tab-content p {
      margin-top: 10px;
  }
  .vehicle-type-display a:hover img {
      transform: scale(1.1);
      text-decoration: none;
  }
  .vehicle-type-display .desktop-row {
      display: flex;
      justify-content: center;
  }
  .vehicle-type-display .mobile-row a {
      color: var(--primary-dark) !important;
      padding: 15px 0;
      transform: perspective(1px) translateZ(0);
      -webkit-transition-duration: 0.3s;
      transition-duration: 0.3s;
      -webkit-transition-property: transform;
      transition-property: transform;
  }
  .vehicle-type-display .mobile-row a:hover {
      transform: scale(1.1);
  }
  .vehicle-type-display .carousel-control.left,
  .vehicle-type-display .carousel-control.right {
      background-image: none;
      color: #fff;
      opacity: 1;
  }
  .vehicle-type-display .carousel-inner {
      position: relative;
      overflow: hidden;
      width: 100%;
  }
  .vehicle-type-display .carousel-inner>.item {
      display: none;
      position: relative;
  }
  .vehicle-type-display .carousel-inner>.item .col-sm-3 {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-evenly;
  }

  @media (max-width: 767px) {
      .vehicle-type-display .mobile-row {
          display: flex !important;
          flex-wrap: wrap;
      }
      .vehicle-type-display .title-row {
        font-size: 28px;
    }
      .vehicle-type-display .col-xs-12 {
          padding: 0 !important;
      }
  }

  @media all and (transform-3d), (-webkit-transform-3d) {
      .vehicle-type-display .carousel-inner>.item.next,
      .vehicle-type-display .carousel-inner>.item.active.right {
          left: 0;
          transform: translate3d(25%, 0, 0);
      }
      .vehicle-type-display .carousel-inner>.item.prev,
      .vehicle-type-display .carousel-inner>.item.active.left {
          left: 0;
          transform: translate3d(-25%, 0, 0);
      }
      .vehicle-type-display .carousel-inner>.item.next.left,
      .vehicle-type-display .carousel-inner>.item.prev.right,
      .vehicle-type-display .carousel-inner>.item.active {
          left: 0;
          transform: translate3d(0, 0, 0);
      }
  }

  .vehicle-type-display .carousel-inner .active,
  .vehicle-type-display .carousel-inner .next,
  .vehicle-type-display .carousel-inner .prev {
      display: block;
  }
  .vehicle-type-display .carousel-inner .active {
      left: 0;
  }
  .vehicle-type-display .carousel-inner .next,
  .vehicle-type-display .carousel-inner .prev {
      position: absolute;
      top: 0;
      width: 100%;
  }
  .vehicle-type-display .carousel-inner .next {
      left: 25%;
  }
  .vehicle-type-display .carousel-inner .prev {
      left: -25%;
  }
  .vehicle-type-display .carousel-inner .next.left,
  .vehicle-type-display .carousel-inner .prev.right {
      left: 0;
  }
  .vehicle-type-display .carousel-inner .active.left {
      left: -25%;
  }
  .vehicle-type-display .carousel-inner .active.right {
      left: 25%;
  }
  .vehicle-type-display .carousel-inner .active.left .col-sm-3 {
    opacity: 0;
  }
  .vehicle-type-display .carousel-inner .active.left .col-sm-3:first-of-type {
    opacity: 1;
  }
  .vehicle-type-display .carousel-inner .active.right .col-sm-3 {
    opacity: 0;
  }
  .vehicle-type-display .carousel-inner .active.right .col-sm-3:last-of-type {
    opacity: 1;
  }
  .vehicle-type-display .nav>li>a {
      color: var(--primary-dark);
      border-radius: 0 !important;
      font-weight: 400;
      border-bottom: 3px solid #fff;
      -moz-transition: all 300ms ease-out;
      -webkit-transition: all 300ms ease-out;
      -o-transition: all 300ms ease-out;
      transition: all 300ms ease-out;
  }
  .vehicle-type-display .nav>li>a:hover {
      background: #fff;
      border-bottom: 3px solid var(--primary-color);
  }
  .vehicle-type-display .nav>li.active>a {
      color: var(--primary-color);
      background: #fff;
      border-bottom: 3px solid var(--primary-color);
      border-top: none;
  }
  .vehicle-type-display[data-brand="cjdr"] .nav>li>a:hover {
      border-bottom: 3px solid var(--secondary-color);
  }
  .vehicle-type-display[data-brand="cjdr"] .nav>li.active>a {
      color: var(--secondary-color);
      border-bottom: 3px solid var(--secondary-color);
  }
</style>